import React from "react";
import {
  getGoogleClientId,
  getFacebookClientId,
} from "../../utils/general-config";
import FacebookLogin from "react-facebook-login";
import { Trans, useTranslation } from "react-i18next";
import InputText from "../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import GoogleCaptcha from "../sign-up/captcha";
const ResumeBuildSignIn = ({
  pwdNavigate,
  signUpNavigate,
  onSignIn,
  disableBtn,
  responseFacebook,
  googleLogin,
  passwordError,
  emailError,
  passwordErrorMsg,
  onEmailChangeHandler,
  emailId,
  onPwdChangeHandler,
  onPasswordKeyPress,
  pwd,
  emailErrorMsg,
  loginError,
  loginErrorMessage,
  showCaptcha,
  onCaptchaSuccess,
  recaptchaRef,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <meta name="description" content={t("sign_in.rb.description_meta")} />
        <title>{t("page_title.sign_in")}</title>
      </Helmet>
      <section className="main-content ">
        <div className="container mx-auto ">
          <div className="form-wrap ">
            <hgroup className="text-center user-page">
              <h1
                className="main-headline uppercase font-bold  text-2xl md:text-xl lg:text-xl"
                style={{ fontFamily: '"Rubik", sans-serif' }}
              >
                {t("sign_in.rb.headline")}
              </h1>
              <p className="sub-para">{t("sign_in.content")}</p>
            </hgroup>
            <div className="social-login ">
              <div className="social-login--facebook">
                <FacebookLogin
                  appId={getFacebookClientId()}
                  fields="name,email"
                  textButton={t("sign_in.signin_with_fb")}
                  callback={responseFacebook}
                  icon={
                    <img
                      src={process.env.PUBLIC_URL + "/static/images/facebook-login.svg"}
                      className="facebook-login-button"
                      id="fbBtn"
                    />
                  }
                />
              </div>
              <div className="social-login--google">
                <button type="button" id="googleBtn" className="google-login-button text-white" onClick={googleLogin}>
                  <div className="bg-white m-px rounded-sm">
                    <img src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"} />
                  </div>
                  <span> {t("sign_in.signin_with_google")}</span>
                </button>
              </div>
            </div>
            <div className="or-container">
              <span></span> {t("sign_in.or")} <span></span>
            </div>
            <div className="form-group">
              <InputText
                showLabel={false}
                id="email"
                text="Email Address"
                onChange={onEmailChangeHandler}
                className=" border-gray-300 !text-[#222] rounded-sm px-3 py-2 border mb-4"
                value={emailId.trim()}
                maxLength={100}
                placeholder={t("sign_in.placeholder_email")}
              />
            </div>
            <div className="form-group">
              <InputText
                showLabel={false}
                id="password"
                text="Password"
                type="password"
                onChange={onPwdChangeHandler}
                value={pwd}
                className="text-sm border-gray-300 !text-[#222] rounded-sm px-3 py-2 border mb-4"
                onKeyPress={onPasswordKeyPress}
                placeholder={t("sign_in.placeholder_password")}
              />
            </div>
            <div className="form-text">
              {emailError && (
                <small key="pswrdErr" className="text-red-500 font-sm">
                  {emailErrorMsg}
                </small>
              )}
            </div>
            <div className="form-text">
              <div className="form-text mb-2">
                {passwordError && (
                  <small key="pswrdErr" className="text-red-500 font-sm">
                    {passwordErrorMsg}
                  </small>
                )}
                  {loginError && <p className="text-center text-red-500">{loginErrorMessage}</p>}
              </div>
              {showCaptcha && (
                <div className="flex flex-row justify-center mb-2">
                  <GoogleCaptcha onCaptchaSuccess={onCaptchaSuccess} recaptchaRef={recaptchaRef} />
                </div>
              )}
              <div className="mb-3">
                <div className=" fixed md:relative bottom-0 left-0 bg-white  border-gray-300 p-2.5 md:p-0 lg:p-0 text-center w-full z-50">
                  {" "}
                  <button
                    isLoading={false}
                    onClick={onSignIn}
                    className="bg-[#fe8c26] hover:bg-[#f07201] transition-all duration-400 ease-out delay-100 active:bg-blue-500 text-white right-0  uppercase rounded font-semibold py-3 w-full"
                  >
                    {t("sign_in.btn_cta")}
                  </button>
                </div>

                <div className="form-container--footer !p-3 text-center ">
                  <p className="text-base md:text-sm lg:text-sm !leading-3">
                    <button
                      isLoading={false}
                      disabled={disableBtn}
                      onClick={pwdNavigate}
                      className="btn btn-link text-[#2ebe6e] hover:text-blue-500"
                    >
                      {t("sign_in.forgot_password")}
                    </button>
                  </p>
                  <p className="text-sm md:text-xs lg:text-xs !leading-3">
                    {t("sign_in.create_account")}
                    <button
                      isLoading={false}
                      disabled={disableBtn}
                      onClick={signUpNavigate}
                      className=" text-[#2ebe6e] hover:text-blue-500 "
                    >
                      {" "}
                      {t("sign_in.create_signup")}
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default ResumeBuildSignIn;
